import store from 'store';
import ConfigService from '@/services/ConfigService';

const STORED_SETTINGS = storedSettings => {
  const settings = {};
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`);
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key];
  });
  return settings;
};

export default {
  state: {
    ...STORED_SETTINGS({
      locale: 'en',
      isMobileView: false,
      isTabletView: false,
      isMobileMenuOpen: false,
      isMenuCollapsed: false,
      isMenuUnfixed: false,
      configVars: {},
      instructionVideos: [],
    }),
  },
  mutations: {
    CHANGE_SETTING(state, payload) {
      store.set(`app.settings.${payload.setting}`, payload.value);
      state[payload.setting] = payload.value;
    },
    SET_CONFIG(state, payload) {
      state.configVars = payload;
    },
    SET_INSTRUCTION_VIDEOS(state, payload) {
      state.instructionVideos = payload;
    },
    SETUP_URL_SETTINGS(state, payload) {
      let queryParams = payload;
      let keys = false;
      if (payload.redirect) {
        const str = payload.redirect;
        const subs = str.substring(str.indexOf('?') + 1);
        if (str.indexOf('?') >= 0) {
          queryParams = JSON.parse('{"' + decodeURI(subs).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
        }
      }
      delete queryParams['redirect'];
      keys = Object.keys(queryParams);
      if (keys.length) {
        keys.forEach(key => {
          let value;
          switch (queryParams[key]) {
            case 'false':
              value = false;
              break;
            case 'true':
              value = true;
              break;
            default:
              value = queryParams[key];
              break;
          }
          if (key in state) {
            state[key] = value;
          }
        });
      }
    },
  },
  actions: {
    async fetchConfig({ commit }) {
      try {
        const resp = await ConfigService.getConfig();
        /* eslint-disable */
        const config = resp.reduce((a, c) => ((a[c.key] = c.value), a), {});
        commit('SET_CONFIG', config);
      } catch (e) {}
    },
    async fetchInstructionVideos({ commit }) {
      try {
        const resp = await ConfigService.getInstructionVideos();
        commit('SET_INSTRUCTION_VIDEOS', resp);
      } catch (e) {}
    },
    updateConfig({ commit }, data) {
      commit('SET_CONFIG', data);
    },
    updateInstructionVideos({ commit }, data) {
      commit('SET_INSTRUCTION_VIDEOS', data);
    },
  },
  getters: {
    state: state => state,
  },
};
